import { useState, useEffect } from "react";
import { resumeBullets } from './data';
import CV from '../../assets/cv.pdf';
import { HiDownload } from 'react-icons/hi';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLaptop, faSchool, faBusinessTime } from "@fortawesome/free-solid-svg-icons";
import ResumeDetails from './ResumeDetails';
import "./Resume.css";

const BULLET_ICONS = { school: faSchool, briefcase: faBusinessTime, laptop: faLaptop };

const Resume = () => {
  const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
  const [carouselOffsetStyle, setCarouselOffsetStyle] = useState({});

  const handleCarousel = (index) => {
    setSelectedBulletIndex(index);
    setCarouselOffsetStyle({ transform: `translateY(${index * -100}%)` });
  };

  const SKILLS_INDEX = resumeBullets.findIndex(b => b.logo === 'laptop');

  useEffect(() => {
    const activateSkillsTab = () => {
      if (window.location.hash === '#skills') handleCarousel(SKILLS_INDEX);
    };
    activateSkillsTab();
    window.addEventListener('hashchange', activateSkillsTab);
    return () => window.removeEventListener('hashchange', activateSkillsTab);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getBullets = () => {
    return resumeBullets.map((bullet, index) => (
      <div
        onClick={() => handleCarousel(index)}
        className={index === selectedBulletIndex ? "bullet selected-bullet" : "bullet"}
        key={bullet.label}
      >
        <FontAwesomeIcon icon={BULLET_ICONS[bullet.logo] ?? faLaptop} />
        <span className="bullet-label">{bullet.label}</span>
      </div>
    ));
  };

  const getResumeScreens = () => {
    return (
      <div style={carouselOffsetStyle} className="resume-details-carousel">
        {ResumeDetails.map((ResumeDetail, index) => <ResumeDetail key={index} />)}
      </div>
    );
  };

  return (
    <section id="resume" style={{ position: 'relative' }}>
      <span id="skills" aria-hidden="true" style={{ position: 'absolute', top: 0 }} />
      <div className="resume-container">
        <h2>Resumé</h2>
        <br />
        <div className="resume-card">
          <div className="resume-bullets">
            <div className="bullet-container">
              {getBullets()}
            </div>
          </div>

          <div className="resume-bullet-details">
            {getResumeScreens()}
          </div>
        </div>
        <br />
        <a href={CV} download className='btn primary'>Download CV <HiDownload /></a>
      </div>
    </section>
  );
};

export default Resume;
